<h2 mat-dialog-title>Step 1: Select Master Suites</h2>
<mat-dialog-content>
  <div class="fields-grid">
    <h3 class="column-header source-header" data-testid="source-column">Source</h3>
    <h3 class="column-header destination-header" data-testid="destination-column">Destination</h3>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="source-ms">
      <mat-label>Source Master Suite</mat-label>
      <mat-select data-testid="source-select" [value]="source" (selectionChange)="setSource($event.value)">
        @for (masterSuite of data.sourceMasterSuites; track masterSuite.id) {
          <mat-option [value]="masterSuite">{{ masterSuite.name }} (touch: {{ masterSuite.touchCount ?? 0 }})</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="destination-ms">
      <mat-label>Destination Master Suite</mat-label>
      <mat-select data-testid="destination-select" [value]="destination" (selectionChange)="setDestination($event.value)" [disabled]="!source">
        @for (masterSuite of availableDestinations; track masterSuite.id) {
          <mat-option [value]="masterSuite">{{ masterSuite.name }} (touch: {{ masterSuite.touchCount ?? 0 }})</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="destination-sv">
      <mat-label>Destination Settings Variant</mat-label>
      <mat-select data-testid="variant-select" [value]="destinationVariant" (selectionChange)="setDestinationVariant($event.value)" [disabled]="!destinationDetail">
        @for (variant of destinationVariants; track variant.id) {
          <mat-option [value]="variant">{{ variant.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="source-ev">
      <mat-label>Source Enhancement Variant</mat-label>
      <mat-select
        data-testid="source-enhancement-variant-select"
        [value]="sourceEnhancementVariant"
        (selectionChange)="setSourceEnhancementVariant($event.value)"
        [disabled]="sourceEnhancementVariants.length === 0"
      >
        @for (variant of sourceEnhancementVariants; track variant.id) {
          <mat-option [value]="variant">{{ variant.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="destination-ev">
      <mat-label>Destination Enhancement Variant</mat-label>
      <mat-select
        data-testid="enhancement-variant-select"
        [value]="destinationEnhancementVariant"
        (selectionChange)="setDestinationEnhancementVariant($event.value)"
        [disabled]="destinationEnhancementVariants.length === 0"
      >
        @for (variant of destinationEnhancementVariants; track variant.id) {
          <mat-option [value]="variant">{{ variant.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" type="button">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()" type="button" [disabled]="!canConfirm()">
    Next
  </button>
</mat-dialog-actions>
